import { gql } from '@apollo/client'

export default gql`
  mutation unarchiveUsers($userIds: [ID]!, $organizationId: ID!) {
    unarchiveUsers(userIds: $userIds, organizationId: $organizationId)
  }
`
